// File: src/components/EventPreview/HostAccessBanner.jsx
import React from 'react';
import { LuInfo } from "react-icons/lu";

const S = {
  wrap: {
    padding: '1px 20px 12px',
    boxSizing: 'border-box',
    maxWidth: 760,
    margin: '0 auto',
  },

  card: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 5,
    border: '1px solid #d9d9d9ee',          // light green border
    background: '#fff',                 // very light green fill
    borderRadius: 12,
    padding: '10px 12px',
  },

  iconPill: {
    width: 26,
    height: 26,
    borderRadius: 9999,
    background: '#FFFFFF',                 // white circle
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: -4,
  },

  title: {
    fontSize: 12,
    fontWeight: 1000,
    color: '#555',                      // deep green
    margin: 0,
    lineHeight: 1.2,
  },

  text: {
    fontSize: 12,
    fontWeight: 500,
    color: '#555',                      // green-gray
    margin: '4px 0 0',
    lineHeight: 1.35,
  },

  infoIcon: {
    fontSize: 14,
    color: '#555',
  },
};
export default function HostAccessBanner({ show = false, hostName = '' }) {
  if (!show) return null;

  const who = hostName ? `${hostName}, this event is yours.` : 'This event is yours.';

  return (
    <div style={S.wrap}>
      <div style={S.card} role="status" aria-live="polite">
        <span style={S.iconPill} aria-hidden>
          <LuInfo style={S.infoIcon} />
        </span>

        <div style={{ minWidth: 0 }}>
          <p style={S.title}>Host access enabled</p>
          <p style={S.text}>
            {who} You can enter without registering or buying a ticket.
          </p>
        </div>
      </div>
    </div>
  );
}
